module.exports = __webpack_public_path__ + "d8f6c37875d150564b2e80fc6167cbdb.png";